export function loadingAction (payload) {
  return {type: 'LOADING/CHANGELOADING', payload}
}
export function errorAction (payload) {
  return {type: 'ERROR/CHANGEERROR', payload}
}
export function dataApiAmiboAction (payload) {
  return {type: 'DATAAPIAMIBO/FETCH', payload}
}
export function addDataMyFavoritAmiboAction (payload) {
  return {type: 'DATAMYFAVORITAMIBO/ADDFAVORIT', payload}
}
export function changeDataMyFavoritAmiboAction (payload) {
  return {type: 'DATAMYFAVORITAMIBO/CHANGEFAVORITE', payload}
}
export function dataDetailAmiboAction (payload) {
  return {type: 'DATADETAILAMIBO/CHANGEDETAILAMIBO', payload}
}

// ================ fetch all data amibo api =================
export function fetchAllDataAmibo () {
  return async (dispatch) => {
    try {
      dispatch(loadingAction(true))
      const response = await fetch ('https://amiiboapi.com/api/amiibo/?amiiboSeries=Super%20Mario%20Bros.')
      const data = await response.json()
      dispatch(dataApiAmiboAction(data.amiibo))
      dispatch(loadingAction(false))
    }
    catch (err) {
      dispatch(errorAction(err))
    }
  }
}
// ================== fetch data detail amibo ============
export function fetchDataDetailAmiboCharacter (payload) {
  return async (dispatch) => {
    try {
      const response = await fetch (`https://amiiboapi.com/api/amiibo/?tail=${payload}`)
      const data = await response.json()
      dispatch(dataDetailAmiboAction(data.amiibo[0]))
    }
    catch (err) {
      console.log(err)
    }
  }
}